export const envENV = window._getEnv('ENV');
export const broncoURLENV = window._getEnv('BRONCO_URL');